export default __webpack_public_path__ + "07ac6c0fcd3766dbfa5394d532cd6721.png";